
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"168","height":"155","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3011_22706)"}},[_c('path',{attrs:{"d":"M102.125 15.938a199.79 199.79 0 00-45.223.74c-12.862 1.677-25.9 4.754-36.622 12.073C9.55 36.064 1.478 48.314 2.028 61.309c.267 6.29 2.48 12.34 5.226 17.999 2.383 4.913 5.236 9.684 9.157 13.478 6.4 6.198 15.125 9.326 23.731 11.601 30.728 8.127 63.724 7.416 94.077-2.019 8.527-2.65 17.117-6.147 23.341-12.562 9.315-9.6 11.675-24.784 7.352-37.454-4.323-12.67-14.597-22.776-26.608-28.645-12.011-5.87-25.627-7.803-36.185-7.763l.006-.006z","fill":"#5B1CAD"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M114.056 30c-6.348 0-15.546 3.032-23.283 17.79l-2.37 4.519-2.734-4.307c-.286-.447-7.376-11.16-22.466-11.16-4.235 0-9.04.914-13.886 2.716-9.219 3.425-14.936 11.563-15.3 21.761-.6 17.097 14.254 42.405 57.6 62.608 6.247-5.449 31.637-28.659 38.255-51.338 2.555-7.1 7.526-26.82.601-34.864C126.274 32.848 120.136 30 114.056 30z","fill":"#F05946"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3011_22706"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 15)","d":"M0 0h165v95H0z"}})])])])
          )
        }
      }
    